
export const API_BASE_URL = "https://rhymecard.avchain.io:31001"; //오라클 
// export const API_BASE_URL = "https://rhymecard-dev.avchain.io:31001"; //오라클테스트 
// export const API_BASE_URL = "https://rhymecard-dev2.avchain.io"; //오라클테스트dev2

export const API_BASE_URL_ISSUER= "https://issuer.avchain.io:31010"; //오라클
// export const API_BASE_URL_ISSUER= "https://issuer-dev.avchain.io:31010"; //오라클테스트
// export const API_BASE_URL_ISSUER= "https://issuer-dev2.avchain.io"; //오라클테스트dev2

export const AUTH_API_URLS = 'https://auth.avchain.io:19100/'; //오라클
// export const AUTH_API_URLS = 'https://auth-dev.avchain.io:19100/'; //오라클테스트
// export const AUTH_API_URLS = 'https://auth-dev2.avchain.io/'; //오라클테스트dev2

export const API_BASE_URL_AGENT_DEV = 'https://rhyme-agent.avchain.io:31007'; //오라클
// export const API_BASE_URL_AGENT_DEV = 'https://rhyme-agent-dev.avchain.io:31007'; //오라클테스트
// export const API_BASE_URL_AGENT_DEV = 'https://rhyme-agent-dev2.avchain.io'; //오라클테스트dev2
